import {handleSend} from '../post'

const update603001 = (data) => {
  return handleSend(data, '60', '3001', data.operaType)
}

const list603002 = (data) => {
  return handleSend(data, '60', '3002')
}

export const HxApiCategory = {
  update603001,
  list603002
}



// WEBPACK FOOTER //
// ./src/api/erp/info/category.js